import { useState, useRef, useEffect } from "react";
import {
  setSearchQuery,
  getSearchState,
  searchProjectGroups,
} from "src/features/projectGroups/state/projectGroupsSlice";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { useTranslation } from "react-i18next";
import { SearchInput } from "src/common/components/SearchInput";
import { PROJECT_GROUP_LIST_WITH_LIMIT_COMPONENT_ID } from "src/features/projectGroups/components/ProjectGroupList";

export type SearchItem = {
  id: number | string;
  name: string;
  type: "projectGroup" | "project";
  projectGroupId: number | string;
};

const ProjectGroupSearchBar = ({
  className,
  isFilteredByPublishedProjects = false,
  disabled,
}: {
  className?: string;
  isFilteredByPublishedProjects?: boolean;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { query: reduxQuery } = useAppSelector(getSearchState);
  const [localQuery, setLocalQuery] = useState("");
  const debounceRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setLocalQuery(reduxQuery);
  }, [reduxQuery]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const handleSearchChange = (value: string) => {
    setLocalQuery(value);
    dispatch(setSearchQuery(value));
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
      debounceRef.current = null;
    }
    const search = () =>
      dispatch(
        searchProjectGroups({
          query: value,
          filterByPublishedProject: isFilteredByPublishedProjects,
          componentId: PROJECT_GROUP_LIST_WITH_LIMIT_COMPONENT_ID,
        }),
      );
    if (!value.trim()) {
      void search();
      return;
    }
    debounceRef.current = setTimeout(() => {
      void search();
    }, 200);
  };

  return (
    <div className={`search-filter-project-groups ${className ?? ""}`} style={{ width: 250 }}>
      <SearchInput
        value={localQuery}
        onChange={handleSearchChange}
        placeholder={`${t("general.search")}...`}
        disabled={disabled}
        className="w-full"
      />
    </div>
  );
};

export default ProjectGroupSearchBar;
